module.exports = __webpack_public_path__ + "static/media/graph.4a85c4d9.svg";